"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initials = void 0;
var initials = function (name, glue) {
  if (glue === void 0) {
    glue = '';
  }
  return name.split(' ').map(function (word) {
    return word[0];
  }).join(glue);
};
exports.initials = initials;